export default "__VITE_ASSET__11bc924c__"